import './styles.css';
import {
  getStore,
  usePlayerStore,
  useAppStore,
  useExamSessionStore,
} from '../../stores/StoreContext';
import { View, Flex } from '@smarterservices/smarter-ui';
import WebrtcMedia from './Webrtc';
import HlsMedia from './Hls';
import { useRef, useMemo, memo, useState, useEffect } from 'react';
import Controls from './Controls';
import CONSTANTS from '../../config/constants';

const MemoizedWebrtcMedia = memo(WebrtcMedia);

const VideoPlayer = (props) => {
  const PlayerStore = getStore('playerStore');
  const AppStore = getStore('appStore');

  const videoWrapperRef = useRef(null);
  const webRtcContainerRef = useRef(null);
  const hlsContainerRef = useRef(null);

  const activeVideoSource = usePlayerStore((state) => state.activeVideoSource);
  const hasTracks = usePlayerStore((state) => state.hasTracks);
  const isRoomConnected = useAppStore((state) => state.isRoomConnected);

  const canHaveLiveVideo = useExamSessionStore(
    (state) => state.canHaveLiveVideo
  );

  const [showControls, setShowControls] = useState(false);

  useEffect(() => {
    setShowControls(false);
    const playbarEnabled = (!('playbar' in AppStore.enabledComponents) || AppStore.enabledComponents.playbar);
    if (!playbarEnabled) {
      setShowControls(false);
    } else {
      if (!canHaveLiveVideo && hasTracks && activeVideoSource === CONSTANTS.VIDEO_SOURCES.RECORDED) {
        setShowControls(true);
      } else if (canHaveLiveVideo && hasTracks && isRoomConnected && activeVideoSource === CONSTANTS.VIDEO_SOURCES.LIVE) {
        setShowControls(true);
      } else {
        setShowControls(false);
      }
    }
  }, [isRoomConnected, hasTracks, AppStore.enabledComponents]);

  /*
    useEffect(() => {
      if (webRtcContainerRef.current) {
        webRtcContainerRef.current.classList.add('webrtc-container');
      }
      if (hlsContainerRef.current) {
        hlsContainerRef.current.classList.add('hls-container');
      }
    }, [webRtcContainerRef, hlsContainerRef]);
    
      useEffect(() => {
        if (activeVideoSource === CONSTANTS.VIDEO_SOURCES.RECORDED) {
          hlsContainerRef.current.classList.remove('hide');
          webRtcContainerRef.current.classList.add('hide');
        } else {
          hlsContainerRef.current.classList.add('hide');
          webRtcContainerRef.current.classList.remove('hide');
        }
      }, [activeVideoSource]);
    */
  // 2. Memoize the element instantiation
  const WebrtcMedia = useMemo(
    () => (
      <MemoizedWebrtcMedia
        {...props}
        enabledComponents={props.enabledComponents}
      />
    ),
    // re‑compute only when these change
    [props, props.enabledComponents]
  );


  return (
    <>
      <Flex as="div" direction="column" height="100%">
        <Flex.Item as="div" shouldGrow shouldShrink>
          <View
            as="div"
            overflow="hidden"
            width="100%"
            height="100%"
            padding="none x-small"
            className="hls-video-player-wrapper"
            style={{ overflow: 'hidden' }}
          >
            {canHaveLiveVideo && WebrtcMedia && WebrtcMedia}
            <HlsMedia />
          </View>
        </Flex.Item>
        <Flex.Item justifyContent="center" alignItems="center">
          <View
            as="div"
            overflow="hidden"
            width="100%"
            height="100%"
            padding="none small"
            style={{ overflow: 'hidden' }}
          >
            {showControls && <Controls />}

          </View>
        </Flex.Item>
      </Flex>
      {/* 
      <View as="div" overflowY="hidden" padding="none small" withVisualDebug>
        <View
          as="div"
          position="relative"
          overflowY="hidden"
          margin="none none none none"
          id="video-wrapper"
          borderRadius="large"
          //        height={`${containers?.video?.height}px`}
          //        minHeight={`${containers?.video?.height}px`}
          withVisualDebug={false}
          onMouseEnter={() => PlayerStore.setShowHoverControls(true)}
          onMouseLeave={() => PlayerStore.setShowHoverControls(false)}
          elementRef={(el) => {
            videoWrapperRef.current = el;
          }}
          style={{}}
          themeOverride={{
            backgroundPrimary: 'black',
          }}
        >
          <Flex
            background="primary"
            className="video-container"
            as="div"
            height="100%"
            withVisualDebug={false}
            themeOverride={{
              backgroundPrimary: 'black',
            }}
          >
            <Flex.Item
              as="div"
              id="webrtc-container"
              className={`webrtc-container`}
              style={{
                zIndex: 7000,
              }}
              elementRef={(el) => {
                webRtcContainerRef.current = el;
              }}
            >
              
            </Flex.Item>
            <Flex.Item
              as="div"
              id="hls-container"
              className={`hls-container`}
              shouldShrink
              shouldGrow
              withVisualDebug={false}
              height="100%"
              style={{
                zIndex: 7000,
              }}
              elementRef={(el) => {
                hlsContainerRef.current = el;
              }}
            >
              
            </Flex.Item>
          </Flex>
        </View>
        
    </View >
      */
      }
    </>
  );
};

export default VideoPlayer;
